import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Loader, Paging } from '@skbkontur/react-ui';
import { listDict } from '../../../constants';
import { EmployeeListContext } from '../EmployeeList.context';
import { ListRow } from './ListRow';
import classes from '../EmployeeList.module.css';
export const ListRows = () => {
    const { state, listType, totalPages, handlePageChange } = useContext(EmployeeListContext);
    return (_jsxs(_Fragment, { children: [_jsx(Loader, { active: state.status === 'loading', type: "big", className: classes.listRows, caption: listDict[listType].loaderCaption, children: state.employees.map((el) => (_jsx(ListRow, { employee: el }, el.id))) }), totalPages > 1 && (_jsx(Paging, { disabled: state.status === 'loading', activePage: state.page, pagesCount: totalPages, onPageChange: handlePageChange, className: classes.listPagination, withoutNavigationHint: true }))] }));
};
